//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "logoDisposition",
  data: function data() {
    return {
      picfileList: [],
      logoData: {}
    };
  },
  created: function created() {
    var _this = this;

    this.$api.logoSetData().then(function (res) {
      if (res.code == 0) {
        _this.logoData = res.data[0];
        _this.picfileList = _this.logoData.logo ? [{
          url: _this.$utils.imgTrow(_this.logoData.logo)
        }] : [];
      }
    });
  },
  methods: {
    imgChange: function imgChange(e) {
      this.picfileList = e;
      this.logoData.logo = e[0] && e[0].response ? $utils.imgTrow(e[0].response.data) : '';
    },
    configLogo: function configLogo() {
      var _this2 = this;

      if (!this.picfileList.length) {
        this.$message.error('请上传LOGO');
        return;
      }

      this.$api.logoSetUpdate({
        id: this.logoData.id,
        logo: this.picfileList[0].response.data
      }).then(function (res) {
        if (res.code == 0) {
          _this2.$message.success('修改成功');
        }
      });
    }
  }
};